export default __webpack_public_path__ + "static/media/eye_off.42e5db0a.svg";